import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import {
	useGetRestaurantDetails,
	useUpdateRestaurantGiftSettings,
} from "../../../../queryHooks";
import CustomPopover from "../../../common/CustomPopover";
import { restaurantGiftsSettingsSchema } from "../../../../validations";
import CS from "../../../../services/commonService";
import { useStore } from "../../../../zustand/store";

const DetailsComponent = () => {
	const details = [
		"Receivers with age less than minimum age would be restricted to receive gifts on your restaurant",
		"Value of minimum age to be set 0 (zero) in case of no age restriction for the receiver of gift",
		"Gifts Purchased prior to modification of this value would still be valid and redeemable",
	];

	return (
		<div>
			{details.map((msg, index) => {
				return <li key={index}>- {msg}</li>;
			})}
		</div>
	);
};

const GiftsSettings = () => {
	const setLoading = useStore((state) => state.setLoading);
	const { slug } = useParams();

	const [isDataChanged, setIsDataChanged] = useState(false);
	const { data: dataRestaurantDetails, refetch } =
		useGetRestaurantDetails(slug);

	const {
		mutateAsync: updateRestaurantGiftSettings,
		data: updateRestaurantGiftSettingsData,
		error: updateRestaurantGiftSettingsError,
		isLoading: updateRestaurantGiftSettingsLoading,
	} = useUpdateRestaurantGiftSettings();

	useEffect(() => {
		if (updateRestaurantGiftSettingsData) {
			if (updateRestaurantGiftSettingsData?.status === "success") {
				CS.showSuccessMessage(updateRestaurantGiftSettingsData?.message);
				refetch();
			} else if (updateRestaurantGiftSettingsData?.status === "fail") {
				CS.showErrorMessage(updateRestaurantGiftSettingsData?.message);
			}
		}
	}, [updateRestaurantGiftSettingsData]);

	useEffect(() => {
		if (updateRestaurantGiftSettingsError) {
			CS.showErrorMessage(
				updateRestaurantGiftSettingsError?.response?.data?.message
			);
		}
	}, [updateRestaurantGiftSettingsError]);

	const {
		values: valuesGifting,
		errors: errorsGifting,
		handleChange: handleChangeGifting,
		handleSubmit: handleSubmitGifting,
		touched: touchedGifting,
	} = useFormik({
		enableReinitialize: true,
		initialValues: {
			giftExpiry: isNaN(
				dataRestaurantDetails?.data?.restaurant_config?.gift_expiry
			)
				? ""
				: dataRestaurantDetails?.data?.restaurant_config?.gift_expiry,
			minAge: isNaN(
				dataRestaurantDetails?.data?.restaurant_config?.min_age_restriction
			)
				? ""
				: dataRestaurantDetails?.data?.restaurant_config?.min_age_restriction,
		},
		validationSchema: restaurantGiftsSettingsSchema,
		onSubmit: (value) => {
			let body = {
				...(dataRestaurantDetails?.data?.restaurant_config?.gift_expiry !==
					value.giftExpiry && {
					gift_expiry: value.giftExpiry,
				}),
				...(dataRestaurantDetails?.data?.restaurant_config
					?.min_age_restriction !== value.minAge && {
					min_age_restriction: value.minAge,
				}),
			};
			if (!isEmpty(body))
				updateRestaurantGiftSettings({
					restaurantId: slug,
					body,
				});
		},
	});

	useEffect(() => {
		let body = {
			...(dataRestaurantDetails?.data?.restaurant_config?.gift_expiry !==
				valuesGifting.giftExpiry && {
				gift_expiry: valuesGifting.giftExpiry,
			}),
			...(dataRestaurantDetails?.data?.restaurant_config
				?.min_age_restriction !== valuesGifting.minAge && {
				min_age_restriction: valuesGifting.minAge,
			}),
		};

		if (Object.keys(body).length > 0) {
			setIsDataChanged(true);
		} else {
			setIsDataChanged(false);
		}
	}, [valuesGifting, dataRestaurantDetails?.data]);

	useEffect(() => {
		setLoading(updateRestaurantGiftSettingsLoading);
	}, [updateRestaurantGiftSettingsLoading]);

	return (
		<>
			<form onSubmit={handleSubmitGifting}>
				<div className="card restaurant-card mb-5">
					<div className="modal-header p-0 pb-3 mb-4 w-100">
						<h5 className="box-title modal-title">
							<i className="bx bx-user mr-1"></i> Gift Settings
						</h5>
					</div>
					<div className="row align-items-center">
						<div className="col-md-12 mt-3">
							<div className="row">
								<div className="form-group col-md-6 mb-md-4 mb-3">
									<label className="mb-1" htmlFor="emailId">
										Gift Voucher Expiry Duration(Days)
										<sup className="text-danger">*</sup>
									</label>
									<div className="w-100">
										<input
											className="form-control"
											id="giftExpiry"
											name="giftExpiry"
											min={0}
											onKeyUp={(e) => {
												e.target.value = Math.abs(e.target.value);
												handleChangeGifting(e);
											}}
											type="number"
											placeholder="Enter gift voucher expiry duration..."
											value={valuesGifting.giftExpiry}
											onChange={handleChangeGifting}
										/>
									</div>
									<span className="text-danger d-block">
										{errorsGifting.giftExpiry && touchedGifting.giftExpiry
											? errorsGifting.giftExpiry
											: null}
									</span>
								</div>
								<div className="form-group col-md-6 mb-md-4 mb-3">
									<label className="mb-1" htmlFor="emailId">
										Minimum Age for Gifting(Years)
										<sup className="text-danger">*</sup>
										<CustomPopover
											title={"Minimum Age for Gifting"}
											DetailsComponent={<DetailsComponent />}
											IconComponent={
												<span
													className="h5 ml-2"
													style={{ textAlign: "center", fontSize: 18 }}
												>
													<i className="bx bx-info-circle" />
												</span>
											}
										/>
									</label>
									<div className="w-100">
										<input
											className="form-control"
											id="minAge"
											name="minAge"
											type="number"
											min={0}
											onKeyUp={(e) => {
												e.target.value = Math.abs(e.target.value);
												handleChangeGifting(e);
											}}
											placeholder="Enter minimum age for gifting..."
											value={valuesGifting.minAge}
											onChange={handleChangeGifting}
										/>
									</div>
									<span className="text-danger d-block">
										{errorsGifting.minAge && touchedGifting.minAge
											? errorsGifting.minAge
											: null}
									</span>
								</div>
								<div className="col-md-12 mt-4 btn-blocks text-right">
									<button
										type="submit"
										disabled={!isDataChanged}
										className="btn btn-primary glow-primary mr-4"
									>
										Save Changes
									</button>
									<Link
										className="btn btn-outline-primary"
										to={`${URL.restaurants}/${slug}`}
									>
										Cancel
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</>
	);
};

export default GiftsSettings;
